import { Box, Chip, Skeleton, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { useCallback, useMemo, useState } from "react";
import { useDevice } from "../../../../providers/DeviceProvider";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { Compare, useEntities } from "@emberly/zenith-client";
import { GetMissionRequestResponseChipStyle } from "../../../../common/missionrequests";
import SentMissionRequestsDialog from "./SentMissionRequestsDialog";
import { MissionRequestEnums } from "../../../../common/constants";

const useStyles = makeStyles()(
  (theme) => ({
    chip: {
      marginLeft: theme.spacing(1),
      fontWeight: 500,
      "& .MuiChip-label": {
        paddingRight: theme.spacing(0.5),
        paddingLeft: theme.spacing(1)
      }
    },
    chipSlim: {
      marginLeft: theme.spacing(0.5),
      fontWeight: 500,
      "& .MuiChip-label": {
        paddingRight: theme.spacing(0.5),
        paddingLeft: theme.spacing(1)
      }
    },
    circle: {
      borderRadius: "50%",
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    circleSlim: {
      borderRadius: "50%",
      width: "18px",
      height: "18px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  })
);

export default function MissionRequestSentChip() {
  const { slim } = useDevice();
  const [open, setOpen] = useState(false);
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { missionId } = useParams();

  const { entities, loading } = useEntities("MissionRequest", useMemo(() => ({
    path: "senderMissionId",
    comparer: Compare.EQ,
    value: missionId
  }), [missionId]));

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);


  const renderedRequests = useMemo(() => {
    let states = { [MissionRequestEnums.ResponseState.New]: 0, [MissionRequestEnums.ResponseState.Rejected]: 0, [MissionRequestEnums.ResponseState.Accepted]: 0 };
    let render = [];

    for (let i = 0; i < entities.length; i++) {
      states[entities[i].response]++;
    }

    for (let i = 0; i < 3; i++) {
      let count = states[i];

      if (count > 0) {
        render.push((
          <Box className={slim ? classes.circleSlim : classes.circle} key={i} style={GetMissionRequestResponseChipStyle(i)}>
            {count}
          </Box>
        ));
      }
    }

    return render;
  }, [entities, slim, classes]);

  return (
    <>
      <Chip
        size="large"
        onClick={onOpen}
        variant="outlined"
        className={slim ? classes.chipSlim : classes.chip}
        label={
          loading ? (
            <Skeleton variant="rounded" width={72} height={"16px"} sx={{ borderRadius: 2, marginRight: 0.5 }} />
          ) : (
            <Stack direction="row" spacing={0.5} alignItems="center">
              <span>
                {t("mission:sentRequests")}
              </span>
              {renderedRequests}
            </Stack>
          )
        }
      />
      {open ? (
        <SentMissionRequestsDialog missionRequests={entities} onClose={onClose} />
      ) : null}
    </>
  )
}
